export const CREATE_MARKER = 'CREATE_MARKER';
export const OPEN_COMMENT_DIALOG = 'OPEN_COMMENT_DIALOG';
export const REMOVE_MARKER = 'REMOVE_MARKER';